module.exports = __webpack_public_path__ + "static/media/google-plus.93ae3f58.png";